module.exports = __webpack_public_path__ + "img/06.bc40dc64.jpg";